export const strings = {
  en: {
    // Common
    loading: 'Loading...',
    logout: 'Logout',
    login: 'Login',
    save: 'Save',
    cancel: 'Cancel',
    edit: 'Edit',
    delete: 'Delete',
    view: 'View',
    search: 'Search',
    filter: 'Filter',
    clear: 'Clear',
    submit: 'Submit',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    close: 'Close',
    open: 'Open',
    yes: 'Yes',
    no: 'No',
    confirm: 'Confirm',
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    info: 'Information',
    language: 'Language',
    actions: 'Actions',
    active: 'Active',
    suspended: 'Suspended',
    noResultsFound: 'No results found',
    noMerchantsFound: 'No merchants found',
    merchantDetails: 'Merchant Details',
    
    // Navigation
    dashboard: 'Dashboard',
    users: 'Users',
    merchants: 'Merchants',
    wallets: 'Wallets',
    products: 'Products',
    offers: 'Offers',
    packages: 'Packages',
    transactions: 'Transactions',
    payouts: 'Payouts',
    auditLogs: 'Audit Logs',
    devices: 'Devices',
    orders: 'Orders',
    sales: 'Sales Analytics',
    payments: 'Payments',
    customers: 'Customers',
    profile: 'Store Profile',
    settings: 'Settings',
    paymentSessions: 'Payment Sessions',
    
    // Admin Panel
    adminPanel: 'Admin Panel',
    eWalletAdmin: 'e-Wallet Admin',
    
    // Merchant Portal
    merchantPortal: 'Merchant Portal',
    merchantDashboard: 'Merchant Dashboard',
    myProducts: 'My Products',
    myOffers: 'My Offers',
    myDevices: 'My Devices',
    myStore: 'My Store',
    storeProfile: 'Store Profile',
    
    // Theme
    lightMode: 'Light Mode',
    darkMode: 'Dark Mode',
    
    // Authentication
    email: 'Email',
    password: 'Password',
    forgotPassword: 'Forgot Password?',
    rememberMe: 'Remember Me',
    signIn: 'Sign In',
    signUp: 'Sign Up',
    
    // User Management
    userName: 'User Name',
    fullName: 'Full Name',
    phoneNumber: 'Phone Number',
    status: 'Status',
    role: 'Role',
    createdAt: 'Created At',
    lastLogin: 'Last Login',
    
    // Wallet
    balance: 'Balance',
    walletId: 'Wallet ID',
    walletType: 'Wallet Type',
    walletStatus: 'Wallet Status',
    
    // Transactions
    transactionId: 'Transaction ID',
    amount: 'Amount',
    type: 'Type',
    date: 'Date',
    description: 'Description',
    id: 'ID',
    user: 'User',
    merchant: 'Merchant',
    name: 'Name',
    
    // Business
    businessName: 'Business Name',
    businessType: 'Business Type',
    address: 'Address',
    contactPerson: 'Contact Person',
    
    // Notifications
    notifications: 'Notifications',
    noNotifications: 'No notifications',
    noUsersFound: 'No users found',
    noTransactionsFound: 'No transactions found',
    blocked: 'Blocked',
    block: 'Block',
    unblock: 'Unblock',
    searchByNameOrEmail: 'Search by name or email...',
    searchByUserMerchantType: 'Search by user, merchant, or type...',
    
    // Errors
    somethingWentWrong: 'Something went wrong',
    networkError: 'Network error',
    unauthorized: 'Unauthorized',
    forbidden: 'Forbidden',
    notFound: 'Not found',
    
    // Success Messages
    savedSuccessfully: 'Saved successfully',
    deletedSuccessfully: 'Deleted successfully',
    updatedSuccessfully: 'Updated successfully',
    
    // Coming Soon
    comingSoon: 'Coming Soon',
    
    // Login Page
    loginToTagPanel: 'Login to Tag Panel',
    accessAdminDashboard: 'Access your admin dashboard',
    emailAddress: 'Email Address',
    enterYourEmail: 'Enter your email',
    enterYourPassword: 'Enter your password',
    signInToTagPanel: 'Sign In to Tag Panel',
    signingIn: 'Signing in...',
    secureAccessToTagDashboard: 'Secure access to your Tag admin dashboard',
    
    // Payment Sessions
    manageActivePaymentSessions: 'Manage active payment sessions',
    nfcSession: 'NFC Session',
    qrSession: 'QR Session',
    fixRegistration: 'Fix Registration',
    activeSaleSessions: 'Active Sale Sessions',
    noActiveSaleSessions: 'No active sale sessions',
    createNewSessionToStartAcceptingPayments: 'Create a new session to start accepting payments',
    session: 'Session',
    expired: 'Expired',
    nfcTag: 'NFC Tag',
    qrHash: 'QR Hash',
    expiresIn: 'Expires in',
    cancelSession: 'Cancel Session',
    simulatePayment: 'Simulate Payment',
    customerShouldScanThisQRCode: 'Customer should scan this QR code',
    qrCode: 'QR Code',
    hash: 'Hash',
    recentCompletedTransactions: 'Recent Completed Transactions',
    lastMonthOnly: 'Last Month Only',
    page: 'Page',
    of: 'of',
    noCompletedTransactionsYet: 'No completed transactions yet',
    noCompletedTransactionsInLastMonth: 'No completed transactions in the last month',
    transaction: 'Transaction',
    product: 'Product',
    customer: 'Customer',
    completed: 'Completed',
    createNewSaleSession: 'Create New Sale Session',
    deviceOptional: 'Device (Optional)',
    autoSelectDefaultDevice: 'Auto-select Default Device',
    noDevicesAvailable: 'No devices available',
    default: 'DEFAULT',
    ifNotSpecifiedWillUseBranchDefaultDevice: 'If not specified, will use your branch\'s default device',
    selectProducts: 'Select Products',
    loadingProducts: 'Loading products...',
    noProductsAvailable: 'No products available',
    quantity: 'Quantity',
    pleaseSelectAtLeastOneProduct: 'Please select at least one product',
    selectedProducts: 'Selected Products',
    totalAmountSAR: 'Total Amount (SAR)',
    totalAutomaticallyCalculated: 'Total is automatically calculated based on selected products',
    creating: 'Creating...',
    createSession: 'Create Session',
    createNewQRSaleSession: 'Create New QR Sale Session',
    unknownProduct: 'Unknown Product',
    nA: 'N/A',
    areYouSureCancelSession: 'Are you sure you want to cancel this session?',
    noAuthenticationTokenAvailable: 'No authentication token available',
    pleaseSelectAtLeastOneProductError: 'Please select at least one product',
    totalAmountMustBeGreaterThanZero: 'Total amount must be greater than 0',
    failedToCreateSession: 'Failed to create session',
    requestTimedOut: 'Request timed out. Please check your connection and try again.',
    networkErrorCheckServer: 'Network error. Please check if the server is running.',
    failedToFetchSessions: 'Failed to fetch sessions',
    failedToFetchProducts: 'Failed to fetch products',
    failedToFetchDevices: 'Failed to fetch devices',
    failedToCancelSession: 'Failed to cancel session',
    failedToFixMerchantRegistration: 'Failed to fix merchant registration',
    paymentFailed: 'Payment failed',
    sessionExpired: 'Session expired',
    scanToPay: 'Scan to Pay',
    mobileAppShouldScanQRCode: 'Mobile app should scan this QR code to process payment',
    qrData: 'QR Data',
    loadingPaymentSessions: 'Loading payment sessions...',
    validationFailed: 'Validation failed',
    merchantNotFound: 'Merchant not found',
    waitingForNfc: 'Waiting for NFC',
    paymentCompleted: 'Payment Completed',
    cancelled: 'Cancelled',

    // Dashboard
    welcomeToDashboard: 'Welcome to your dashboard',
    recentActivity: 'Recent Activity',
    newTransaction: 'New transaction',
    newTransactionAdded: 'A new transaction was added to the system',
    minutesAgo5: '5 minutes ago',
    noRecentActivity: 'No recent activity yet',
    activityChartTitle: 'Transaction activity',
    activityChartSubtitle: 'Credits vs debits over the last 14 days',
    dailyTxChartTitle: 'Daily transactions',
    dailyTxChartSubtitle: 'Number of ledger transactions per day',
    credits: 'Credits',
    debits: 'Debits',
    transactionCount: 'Transactions',
    credit: 'Credit',
    debit: 'Debit',
    justNow: 'Just now',
    minutesAgo: '{n}m ago',
    hoursAgo: '{n}h ago',
    daysAgo: '{n}d ago',
    publicLinks: 'Public Links',
    merchantRegistration: 'Merchant Registration',

    // Packages
    addPackage: 'Add Package',
    editPackage: 'Edit Package',
    packagesTitle: 'Packages',
    discountPercent: 'Discount %',
    validityDays: 'Validity (days)',
    activeYes: 'Yes',
    activeNo: 'No',
    areYouSureDeletePackage: 'Are you sure you want to delete this package?',
    update: 'Update',
    create: 'Create',

    // Merchant Dashboard
    merchantDashboardTitle: 'Merchant Dashboard',
    merchantDashboardSubtitle: "Welcome back! Here's your business overview",
    refresh: 'Refresh',
    branchOverview: 'Branch Overview',
    totalBranches: 'Total Branches',
    activeBranches: 'Active Branches',
    totalDevices: 'Total Devices',
    defaultDevices: 'Default Devices',
    branchSummary: 'Branch Summary',
    code: 'Code',
    manager: 'Manager',
    devicesLabel: 'Devices',
    defaultLabel: 'Default',
    quickActions: 'Quick Actions',
    startSale: 'Start Sale',
    createNewPaymentSession: 'Create a new payment session',
    addProduct: 'Add Product',
    addNewProductToCatalog: 'Add a new product to your catalog',
    viewOffers: 'View Offers',
    viewProductOffers: 'View your product offers (read-only)',
    manageDevices: 'Manage Devices',
    configurePaymentDevices: 'Configure payment devices',
    manageBranches: 'Manage Branches',
    configureBusinessBranches: 'Configure business branches',
    recentActivityMerchant: 'Recent Activity',
    startByCreatingFirstSale: 'Start by creating your first sale!',
    totalPaymentsReceived: 'Total Payments Received',
    totalDiscountsGiven: 'Total Discounts Given',
    totalPayments: 'Total Payments',
    totalProducts: 'Total Products',
    
    // Product Sales Analytics
    productSalesAnalytics: 'Product Sales Analytics',
    trackProductPerformance: 'Track product performance and sales metrics',
    filters: 'Filters',
    dateFrom: 'Date From',
    dateTo: 'Date To',
    searchProduct: 'Search Product',
    productName: 'Product Name',
    sortBy: 'Sort By',
    sortOrder: 'Sort Order',
    ascending: 'Ascending',
    descending: 'Descending',
    pageSize: 'Page Size',
    productsTracked: 'Products Tracked',
    totalSales: 'Total Sales',
    avgOrderValue: 'Avg Order Value',
    productPerformance: 'Product Performance',
    salesCount: 'Sales Count',
    discountGiven: 'Discount Given',
    lastSale: 'Last Sale',
    noSalesDataFound: 'No sales data found',
    tryAdjustingFilters: 'Try adjusting your filters or date range',
    showing: 'Showing',
    to: 'to',
    productsLowercase: 'products',
    revenue: 'Revenue',
    totalRevenue: 'Total Revenue',
    totalDiscounts: 'Total Discounts',
    avgOrderValueOverall: 'Average Order Value Overall',
    productNamePlaceholder: 'Product name...',
    salesCountLabel: 'Sales Count',
    revenueLabel: 'Revenue',
    discountGivenLabel: 'Discount Given',
    avgOrderValueLabel: 'Avg Order Value',
    lastSaleLabel: 'Last Sale',
    
    // Merchant Profile
    merchantProfile: 'Merchant Profile',
    manageYourBusinessProfile: 'Manage your business profile information',
    businessInformation: 'Business Information',
    legalName: 'Legal Name',
    accountInformation: 'Account Information',
    bankInformation: 'Bank Information',
    bankAccountIBAN: 'Bank Account IBAN',
    bankAccountHolder: 'Bank Account Holder',
    additionalInformation: 'Additional Information',
    crNumber: 'CR Number',
    updatedAt: 'Updated At',
    imageGallery: 'Image Gallery',
    primary: 'Primary',
    coverImage: 'Cover Image',
    profileNotFound: 'Profile not found',
    retry: 'Retry',
    failedToFetchProfile: 'Failed to fetch profile',
    failedToUpdateProfile: 'Failed to update profile',
    profileUpdatedSuccessfully: 'Profile updated successfully',
    saving: 'Saving...',
    username: 'Username',
    city: 'City',
    businessCategory: 'Business Category',
    image: 'Image',
    
    // Merchant Activation
    activate: 'Activate',
    suspend: 'Suspend',
    activating: 'Activating...',
    suspending: 'Suspending...',
    merchantActivatedSuccessfully: 'Merchant activated successfully',
    merchantSuspendedSuccessfully: 'Merchant suspended successfully',
    activationSuccess: 'Activation Successful',
    activationWarning: 'Activation Warning',
    activationError: 'Activation Failed',
    userAccountCreated: 'User account created successfully',
    passwordResetLinkSent: 'Password setup link has been sent via email',
    emailSentSuccessfully: 'Email sent successfully',
    emailFailedToSend: 'Failed to send email',
    accountActivatedButEmailFailed: 'Account was activated successfully, but password reset email could not be sent',
    pleaseResendEmail: 'Please use the resend button to send the email again',
    resendPasswordResetLink: 'Resend Password Reset Link',
    resendingEmail: 'Resending email...',
    resendEmail: 'Resend Email',
    emailAlreadyExists: 'Email already exists',
    userAlreadyExists: 'User with this email already exists in the system',
    merchantAlreadyHasAccount: 'Merchant already has a user account',
    failedToActivateMerchant: 'Failed to activate merchant',
    failedToSuspendMerchant: 'Failed to suspend merchant',
    passwordResetLinkSentSuccessfully: 'Password reset link has been sent successfully',
    timeline: 'Timeline',
    phone: 'Phone',
    
    // Password Reset
    resetPassword: 'Reset Password',
    enterNewPassword: 'Enter your new password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    resettingPassword: 'Resetting Password...',
    passwordResetSuccess: 'Password reset successfully!',
    passwordResetFailed: 'Failed to reset password',
    invalidToken: 'Invalid Token',
    invalidOrExpiredToken: 'Invalid or expired reset token. Please request a new password reset link.',
    passwordsDoNotMatch: 'Passwords do not match',
    passwordMinLength: 'Password must be at least 6 characters',
    passwordMinLengthHint: 'Password must be at least 6 characters long',
    redirectingToLogin: 'Redirecting to login page...',
    backToLogin: 'Back to Login',
    
    // Settings
    manageSystemSettings: 'Manage system settings and configurations',
    
    // App Version Management
    appVersions: 'App Versions',
    appVersionManagement: 'App Version Management',
    addAppVersion: 'Add App Version',
    editAppVersion: 'Edit App Version',
    forceUpdateVersion: 'Force Update Version',
    minimumVersion: 'Minimum Version',
    message: 'Message',
    iosStoreUrl: 'iOS Store URL',
    androidStoreUrl: 'Android Store URL',
    versionFormatHint: 'Format: X.Y.Z (e.g., 1.0.0)',
    updateMessagePlaceholder: 'Enter update message for users...',
    noAppVersionsFound: 'No app versions found',
    noVersion: 'No Version',
    areYouSureDeleteVersion: 'Are you sure you want to delete this app version?',
    inactive: 'Inactive',
  },
  
  ar: {
    // Common
    loading: 'جاري التحميل...',
    logout: 'تسجيل الخروج',
    login: 'تسجيل الدخول',
    save: 'حفظ',
    cancel: 'إلغاء',
    edit: 'تعديل',
    delete: 'حذف',
    view: 'عرض',
    search: 'بحث',
    filter: 'تصفية',
    clear: 'مسح',
    submit: 'إرسال',
    back: 'رجوع',
    next: 'التالي',
    previous: 'السابق',
    close: 'إغلاق',
    open: 'فتح',
    yes: 'نعم',
    no: 'لا',
    confirm: 'تأكيد',
    error: 'خطأ',
    success: 'نجح',
    warning: 'تحذير',
    info: 'معلومات',
    language: 'اللغة',
    actions: 'الإجراءات',
    active: 'نشط',
    suspended: 'معلق',
    noResultsFound: 'لم يتم العثور على نتائج',
    noMerchantsFound: 'لم يتم العثور على تجار',
    merchantDetails: 'تفاصيل التاجر',
    
    // Navigation
    dashboard: 'لوحة التحكم',
    users: 'المستخدمين',
    merchants: 'التجار',
    wallets: 'المحافظ',
    products: 'المنتجات',
    offers: 'العروض',
    packages: 'الباقات',
    transactions: 'المعاملات',
    payouts: 'المدفوعات',
    auditLogs: 'سجلات التدقيق',
    devices: 'الأجهزة',
    orders: 'الطلبات',
    sales: 'تحليلات المبيعات',
    payments: 'المدفوعات',
    customers: 'العملاء',
    profile: 'ملف المتجر',
    settings: 'الإعدادات',
    paymentSessions: 'جلسات الدفع',
    
    // Admin Panel
    adminPanel: 'لوحة الإدارة',
    eWalletAdmin: 'إدارة المحفظة الإلكترونية',
    
    // Merchant Portal
    merchantPortal: 'بوابة التاجر',
    merchantDashboard: 'لوحة تحكم التاجر',
    myProducts: 'منتجاتي',
    myOffers: 'عروضي',
    myDevices: 'أجهزتي',
    myStore: 'متجري',
    storeProfile: 'ملف المتجر',
    
    // Theme
    lightMode: 'الوضع الفاتح',
    darkMode: 'الوضع الداكن',
    
    // Authentication
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    forgotPassword: 'نسيت كلمة المرور؟',
    rememberMe: 'تذكرني',
    signIn: 'تسجيل الدخول',
    signUp: 'إنشاء حساب',
    
    // User Management
    userName: 'اسم المستخدم',
    fullName: 'الاسم الكامل',
    phoneNumber: 'رقم الهاتف',
    status: 'الحالة',
    role: 'الدور',
    createdAt: 'تاريخ الإنشاء',
    lastLogin: 'آخر تسجيل دخول',
    
    // Wallet
    balance: 'الرصيد',
    walletId: 'معرف المحفظة',
    walletType: 'نوع المحفظة',
    walletStatus: 'حالة المحفظة',
    
    // Transactions
    transactionId: 'معرف المعاملة',
    amount: 'المبلغ',
    type: 'النوع',
    date: 'التاريخ',
    description: 'الوصف',
    id: 'المعرف',
    user: 'المستخدم',
    merchant: 'التاجر',
    name: 'الاسم',
    
    // Business
    businessName: 'اسم العمل',
    businessType: 'نوع العمل',
    address: 'العنوان',
    contactPerson: 'الشخص المسؤول',
    
    // Notifications
    notifications: 'الإشعارات',
    noNotifications: 'لا توجد إشعارات',
    noUsersFound: 'لا يوجد مستخدمون',
    noTransactionsFound: 'لا توجد معاملات',
    blocked: 'محظور',
    block: 'حظر',
    unblock: 'إلغاء الحظر',
    searchByNameOrEmail: 'ابحث بالاسم أو البريد الإلكتروني...',
    searchByUserMerchantType: 'ابحث بالمستخدم أو التاجر أو النوع...',
    
    // Errors
    somethingWentWrong: 'حدث خطأ ما',
    networkError: 'خطأ في الشبكة',
    unauthorized: 'غير مصرح',
    forbidden: 'ممنوع',
    notFound: 'غير موجود',
    
    // Success Messages
    savedSuccessfully: 'تم الحفظ بنجاح',
    deletedSuccessfully: 'تم الحذف بنجاح',
    updatedSuccessfully: 'تم التحديث بنجاح',
    
    // Coming Soon
    comingSoon: 'قريباً',
    
    // Login Page
    loginToTagPanel: 'تسجيل الدخول',
    accessAdminDashboard: 'الوصول إلى لوحة الإدارة',
    emailAddress: 'عنوان البريد الإلكتروني',
    enterYourEmail: 'أدخل بريدك الإلكتروني',
    enterYourPassword: 'أدخل كلمة المرور',
    signInToTagPanel: 'تسجيل الدخول',
    signingIn: 'جاري تسجيل الدخول...',
    secureAccessToTagDashboard: 'وصول آمن إلى لوحة إدارة تاق',
    
    // Payment Sessions
    manageActivePaymentSessions: 'إدارة جلسات الدفع النشطة',
    nfcSession: 'جلسة NFC',
    qrSession: 'جلسة QR',
    fixRegistration: 'إصلاح التسجيل',
    activeSaleSessions: 'جلسات البيع النشطة',
    noActiveSaleSessions: 'لا توجد جلسات بيع نشطة',
    createNewSessionToStartAcceptingPayments: 'قم بإنشاء جلسة جديدة لبدء قبول المدفوعات',
    session: 'الجلسة',
    expired: 'منتهية',
    nfcTag: 'علامة NFC',
    qrHash: 'رمز QR',
    expiresIn: 'ينتهي خلال',
    cancelSession: 'إلغاء الجلسة',
    simulatePayment: 'محاكاة الدفع',
    customerShouldScanThisQRCode: 'يجب على العميل مسح رمز QR هذا',
    qrCode: 'رمز QR',
    hash: 'الرمز',
    recentCompletedTransactions: 'المعاملات المكتملة الأخيرة',
    lastMonthOnly: 'الشهر الأخير فقط',
    page: 'صفحة',
    of: 'من',
    noCompletedTransactionsYet: 'لا توجد معاملات مكتملة بعد',
    noCompletedTransactionsInLastMonth: 'لا توجد معاملات مكتملة في الشهر الأخير',
    transaction: 'المعاملة',
    product: 'المنتج',
    customer: 'العميل',
    completed: 'مكتمل',
    createNewSaleSession: 'إنشاء جلسة بيع جديدة',
    deviceOptional: 'الجهاز (اختياري)',
    autoSelectDefaultDevice: 'اختيار الجهاز الافتراضي تلقائياً',
    noDevicesAvailable: 'لا توجد أجهزة متاحة',
    default: 'افتراضي',
    ifNotSpecifiedWillUseBranchDefaultDevice: 'إذا لم يتم التحديد، سيتم استخدام الجهاز الافتراضي لفرعك',
    selectProducts: 'اختر المنتجات',
    loadingProducts: 'جاري تحميل المنتجات...',
    noProductsAvailable: 'لا توجد منتجات متاحة',
    quantity: 'الكمية',
    pleaseSelectAtLeastOneProduct: 'يرجى اختيار منتج واحد على الأقل',
    selectedProducts: 'المنتجات المحددة',
    totalAmountSAR: 'إجمالي المبلغ (ريال)',
    totalAutomaticallyCalculated: 'يتم حساب الإجمالي تلقائياً بناءً على المنتجات المحددة',
    creating: 'جاري الإنشاء...',
    createSession: 'إنشاء الجلسة',
    createNewQRSaleSession: 'إنشاء جلسة بيع QR جديدة',
    unknownProduct: 'منتج غير معروف',
    nA: 'غير متاح',
    areYouSureCancelSession: 'هل أنت متأكد أنك تريد إلغاء هذه الجلسة؟',
    noAuthenticationTokenAvailable: 'لا يوجد رمز مصادقة متاح',
    pleaseSelectAtLeastOneProductError: 'يرجى اختيار منتج واحد على الأقل',
    totalAmountMustBeGreaterThanZero: 'يجب أن يكون إجمالي المبلغ أكبر من 0',
    failedToCreateSession: 'فشل في إنشاء الجلسة',
    requestTimedOut: 'انتهت مهلة الطلب. يرجى التحقق من الاتصال والمحاولة مرة أخرى.',
    networkErrorCheckServer: 'خطأ في الشبكة. يرجى التحقق من تشغيل الخادم.',
    failedToFetchSessions: 'فشل في جلب الجلسات',
    failedToFetchProducts: 'فشل في جلب المنتجات',
    failedToFetchDevices: 'فشل في جلب الأجهزة',
    failedToCancelSession: 'فشل في إلغاء الجلسة',
    failedToFixMerchantRegistration: 'فشل في إصلاح تسجيل التاجر',
    paymentFailed: 'فشل الدفع',
    sessionExpired: 'انتهت الجلسة',
    scanToPay: 'امسح للدفع',
    mobileAppShouldScanQRCode: 'يجب على تطبيق الهاتف المحمول مسح رمز QR هذا لمعالجة الدفع',
    qrData: 'بيانات QR',
    loadingPaymentSessions: 'جاري تحميل جلسات الدفع...',
    validationFailed: 'فشل التحقق',
    merchantNotFound: 'التاجر غير موجود',
    waitingForNfc: 'في انتظار NFC',
    paymentCompleted: 'تم الدفع',
    cancelled: 'ملغي',

    // Dashboard
    welcomeToDashboard: 'مرحباً بك في لوحة التحكم',
    recentActivity: 'النشاط الأخير',
    newTransaction: 'معاملة جديدة',
    newTransactionAdded: 'تم إضافة معاملة جديدة إلى النظام',
    minutesAgo5: 'منذ 5 دقائق',
    noRecentActivity: 'لا يوجد نشاط حديث بعد',
    activityChartTitle: 'نشاط المعاملات',
    activityChartSubtitle: 'الإيداعات مقابل السحوبات خلال آخر 14 يوم',
    dailyTxChartTitle: 'المعاملات اليومية',
    dailyTxChartSubtitle: 'عدد المعاملات في السجل لكل يوم',
    credits: 'إيداعات',
    debits: 'سحوبات',
    transactionCount: 'المعاملات',
    credit: 'إيداع',
    debit: 'سحب',
    justNow: 'الآن',
    minutesAgo: 'منذ {n} د',
    hoursAgo: 'منذ {n} س',
    daysAgo: 'منذ {n} ي',
    publicLinks: 'روابط عامة',
    merchantRegistration: 'تسجيل التاجر',

    // Packages
    addPackage: 'إضافة باقة',
    editPackage: 'تعديل الباقة',
    packagesTitle: 'الباقات',
    discountPercent: 'نسبة الخصم',
    validityDays: 'الصلاحية (أيام)',
    activeYes: 'نعم',
    activeNo: 'لا',
    areYouSureDeletePackage: 'هل أنت متأكد من حذف هذه الباقة؟',
    update: 'تحديث',
    create: 'إنشاء',

    // Merchant Dashboard
    merchantDashboardTitle: 'لوحة تحكم التاجر',
    merchantDashboardSubtitle: 'مرحباً بعودتك! هذا ملخص أعمالك',
    refresh: 'تحديث',
    branchOverview: 'نظرة عامة على الفروع',
    totalBranches: 'إجمالي الفروع',
    activeBranches: 'الفروع النشطة',
    totalDevices: 'إجمالي الأجهزة',
    defaultDevices: 'الأجهزة الافتراضية',
    branchSummary: 'ملخص الفروع',
    code: 'الرمز',
    manager: 'المدير',
    devicesLabel: 'الأجهزة',
    defaultLabel: 'افتراضي',
    quickActions: 'إجراءات سريعة',
    startSale: 'بدء بيع',
    createNewPaymentSession: 'إنشاء جلسة دفع جديدة',
    addProduct: 'إضافة منتج',
    addNewProductToCatalog: 'إضافة منتج جديد إلى قائمتك',
    viewOffers: 'عرض العروض',
    viewProductOffers: 'عرض عروض منتجاتك (قراءة فقط)',
    manageDevices: 'إدارة الأجهزة',
    configurePaymentDevices: 'تهيئة أجهزة الدفع',
    manageBranches: 'إدارة الفروع',
    configureBusinessBranches: 'تهيئة فروع العمل',
    recentActivityMerchant: 'النشاط الأخير',
    startByCreatingFirstSale: 'ابدأ بإنشاء أول عملية بيع!',
    totalPaymentsReceived: 'إجمالي المدفوعات المستلمة',
    totalDiscountsGiven: 'إجمالي الخصومات المقدمة',
    totalPayments: 'إجمالي المدفوعات',
    totalProducts: 'إجمالي المنتجات',
    
    // Product Sales Analytics
    productSalesAnalytics: 'تحليلات مبيعات المنتجات',
    trackProductPerformance: 'تتبع أداء المنتجات ومقاييس المبيعات',
    filters: 'مرشحات',
    dateFrom: 'من تاريخ',
    dateTo: 'إلى تاريخ',
    searchProduct: 'بحث عن منتج',
    productName: 'اسم المنتج',
    sortBy: 'ترتيب حسب',
    sortOrder: 'ترتيب',
    ascending: 'تصاعدي',
    descending: 'تنازلي',
    pageSize: 'حجم الصفحة',
    productsTracked: 'المنتجات المتتبعة',
    totalSales: 'إجمالي المبيعات',
    avgOrderValue: 'متوسط قيمة الطلب',
    productPerformance: 'أداء المنتجات',
    salesCount: 'عدد المبيعات',
    discountGiven: 'الخصم الممنوح',
    lastSale: 'آخر مبيعة',
    noSalesDataFound: 'لم يتم العثور على بيانات مبيعات',
    tryAdjustingFilters: 'حاول تعديل المرشحات أو النطاق الزمني',
    showing: 'عرض',
    to: 'إلى',
    productsLowercase: 'منتجات',
    revenue: 'الإيرادات',
    totalRevenue: 'إجمالي الإيرادات',
    totalDiscounts: 'إجمالي الخصومات',
    avgOrderValueOverall: 'متوسط قيمة الطلب الإجمالي',
    productNamePlaceholder: 'اسم المنتج...',
    salesCountLabel: 'عدد المبيعات',
    revenueLabel: 'الإيرادات',
    discountGivenLabel: 'الخصم الممنوح',
    avgOrderValueLabel: 'متوسط قيمة الطلب',
    lastSaleLabel: 'آخر مبيعة',
    
    // Merchant Profile
    merchantProfile: 'ملف التاجر',
    manageYourBusinessProfile: 'إدارة معلومات ملف العمل الخاص بك',
    businessInformation: 'معلومات العمل',
    legalName: 'الاسم القانوني',
    accountInformation: 'معلومات الحساب',
    bankInformation: 'معلومات البنك',
    bankAccountIBAN: 'رقم الحساب البنكي (IBAN)',
    bankAccountHolder: 'صاحب الحساب البنكي',
    additionalInformation: 'معلومات إضافية',
    crNumber: 'رقم السجل التجاري',
    updatedAt: 'تاريخ التحديث',
    imageGallery: 'معرض الصور',
    primary: 'رئيسي',
    coverImage: 'صورة الغلاف',
    profileNotFound: 'الملف غير موجود',
    retry: 'إعادة المحاولة',
    failedToFetchProfile: 'فشل في جلب الملف',
    failedToUpdateProfile: 'فشل في تحديث الملف',
    profileUpdatedSuccessfully: 'تم تحديث الملف بنجاح',
    saving: 'جاري الحفظ...',
    username: 'اسم المستخدم',
    city: 'المدينة',
    businessCategory: 'فئة العمل',
    image: 'صورة',
    
    // Merchant Activation
    activate: 'تفعيل',
    suspend: 'تعليق',
    activating: 'جاري التفعيل...',
    suspending: 'جاري التعليق...',
    merchantActivatedSuccessfully: 'تم تفعيل التاجر بنجاح',
    merchantSuspendedSuccessfully: 'تم تعليق التاجر بنجاح',
    activationSuccess: 'تم التفعيل بنجاح',
    activationWarning: 'تحذير التفعيل',
    activationError: 'فشل التفعيل',
    userAccountCreated: 'تم إنشاء حساب المستخدم بنجاح',
    passwordResetLinkSent: 'تم إرسال رابط إعداد كلمة المرور عبر الإيميل',
    emailSentSuccessfully: 'تم إرسال الإيميل بنجاح',
    emailFailedToSend: 'فشل إرسال الإيميل',
    accountActivatedButEmailFailed: 'تم تفعيل الحساب بنجاح، لكن فشل إرسال إيميل إعادة تعيين كلمة المرور',
    pleaseResendEmail: 'يرجى استخدام زر إعادة الإرسال لإرسال الإيميل مرة أخرى',
    resendPasswordResetLink: 'إعادة إرسال رابط إعادة تعيين كلمة المرور',
    resendingEmail: 'جاري إعادة إرسال الإيميل...',
    resendEmail: 'إعادة إرسال الإيميل',
    emailAlreadyExists: 'البريد الإلكتروني موجود بالفعل',
    userAlreadyExists: 'يوجد مستخدم بهذا البريد الإلكتروني في النظام',
    merchantAlreadyHasAccount: 'التاجر لديه حساب مستخدم بالفعل',
    failedToActivateMerchant: 'فشل في تفعيل التاجر',
    failedToSuspendMerchant: 'فشل في تعليق التاجر',
    passwordResetLinkSentSuccessfully: 'تم إرسال رابط إعادة تعيين كلمة المرور بنجاح',
    timeline: 'الجدول الزمني',
    phone: 'الهاتف',
    
    // Password Reset
    resetPassword: 'إعادة تعيين كلمة المرور',
    enterNewPassword: 'أدخل كلمة المرور الجديدة',
    newPassword: 'كلمة المرور الجديدة',
    confirmPassword: 'تأكيد كلمة المرور',
    resettingPassword: 'جاري إعادة تعيين كلمة المرور...',
    passwordResetSuccess: 'تم إعادة تعيين كلمة المرور بنجاح!',
    passwordResetFailed: 'فشل إعادة تعيين كلمة المرور',
    invalidToken: 'رمز غير صحيح',
    invalidOrExpiredToken: 'رمز إعادة التعيين غير صحيح أو منتهي الصلاحية. يرجى طلب رابط جديد.',
    passwordsDoNotMatch: 'كلمات المرور غير متطابقة',
    passwordMinLength: 'يجب أن تكون كلمة المرور 6 أحرف على الأقل',
    passwordMinLengthHint: 'يجب أن تكون كلمة المرور 6 أحرف على الأقل',
    redirectingToLogin: 'جاري التوجيه إلى صفحة تسجيل الدخول...',
    backToLogin: 'العودة لتسجيل الدخول',
    
    // Settings
    manageSystemSettings: 'إدارة إعدادات وتكوينات النظام',
    
    // App Version Management
    appVersions: 'إصدارات التطبيق',
    appVersionManagement: 'إدارة إصدارات التطبيق',
    addAppVersion: 'إضافة إصدار تطبيق',
    editAppVersion: 'تعديل إصدار التطبيق',
    forceUpdateVersion: 'إصدار التحديث الإجباري',
    minimumVersion: 'الحد الأدنى للإصدار',
    message: 'الرسالة',
    iosStoreUrl: 'رابط متجر iOS',
    androidStoreUrl: 'رابط متجر Android',
    versionFormatHint: 'التنسيق: X.Y.Z (مثال: 1.0.0)',
    updateMessagePlaceholder: 'أدخل رسالة التحديث للمستخدمين...',
    noAppVersionsFound: 'لم يتم العثور على إصدارات التطبيق',
    noVersion: 'لا يوجد إصدار',
    areYouSureDeleteVersion: 'هل أنت متأكد من حذف إصدار التطبيق هذا؟',
    inactive: 'غير نشط',
  }
};

export const getString = (key, language = 'en') => {
  return strings[language]?.[key] || strings.en[key] || key;
};
